import React from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import styles from './Results.module.scss'
import { addRecentSearch } from '@/helpers/props'
import Icon from '@/components/UI/icon/Icon'
import Box from '@/components/UI/box/Box'
import Typography from '@/components/UI/typography/Typography'

const Results = ({
  searchResult,
  closeHandler,
  handleClickCity,
  searchTxt,
}) => {
  const router = useRouter()
  return (
    <Box className="bottom-main-search">
      {searchResult.houses.length !== 0 && (
        <Box className="bottom-main-search-list">
          <Typography variant={'title'}>اقامتگاه‌ها</Typography>
          {searchResult.houses.map((item, index) => {
            const type = item.type === 'apartment' ? 'آپارتمان' : 'ویلایی'
            const location = `${item.province} ${item.city}`
            const rooms =
              item.rooms_count > 0 ? `${item.rooms_count} خوابه` : 'بدون خواب'

            const details = `${type} . ${rooms} . ${location}`

            return (
              <Box
                className={styles['house-container']}
                key={`house-result-item---${index}`}
                onClick={() => {
                  closeHandler()
                  router.push({
                    pathname: `/houses/show/${item.id}`,
                  })
                }}
              >
                <Image
                  className={styles['image-container']}
                  src={item.cover_photo}
                  alt={item.title}
                  width={64}
                  height={48}
                />
                <Box>
                  <Box className={styles['house-id']} component={'strong'}>
                    کد {item.id} .
                  </Box>
                  <Typography variant={'bodyM'} color={'neutral_main'}>
                    {details}
                  </Typography>
                  <Box>
                    <Typography variant={'bodyL'}>{item.title}</Typography>
                  </Box>
                </Box>
              </Box>
            )
          })}
        </Box>
      )}
      {[...searchResult.regions, ...searchResult.near_regions].length !== 0 && (
        <Box>
          <Typography variant={'title'}>شهرها</Typography>
          {(searchTxt.startsWith('شم') || searchTxt.includes('شمال')) && (
            <Box
              className={styles['item-container']}
              onClick={() => {
                router.push({
                  pathname: '/search',
                  query: { phrase: 'شمال' },
                })
                addRecentSearch({
                  name: 'شمال',
                  type: 'phrase',
                })
                closeHandler()
              }}
            >
              <Box className={styles['icon-container']}>
                <Icon name="location" type="primary" />
              </Box>
              <Typography variant={'bodyM'}>همه اقامتگاه‌های شمال</Typography>
            </Box>
          )}
          {[...searchResult.regions, ...searchResult.near_regions].map(
            (item, index) => {
              const isProvince = item.type === 'province'
              return (
                <Box
                  onClick={() => {
                    handleClickCity(item.name, item.type)
                  }}
                  className={styles['item-container']}
                  key={`city-list-item----${index}`}
                >
                  <Box className={styles['icon-container']}>
                    <Icon name="location" type="primary" />
                  </Box>
                  <Box className={styles['content-container']}>
                    <Typography variant={'bodyM'}>
                      {` ${item.type_label} `}
                      {item.name}
                    </Typography>
                    {!isProvince && (
                      <Typography
                        variant={'bodyM'}
                        color={'neutral_600'}
                      >{` استان ${item.province.name} `}</Typography>
                    )}
                    <Typography
                      variant={'bodyS'}
                      className={styles['houses-count']}
                    >
                      {item.houses_count} اقامتگاه
                    </Typography>
                  </Box>
                </Box>
              )
            },
          )}
        </Box>
      )}
    </Box>
  )
}

export default Results
